module.exports = __webpack_public_path__ + "img/logo.05240e5a.png";